import { unlock } from 'tua-body-scroll-lock';
import PerfectScrollbar from 'perfect-scrollbar';
import getCurrentPageClass from '../utils/_pageClass';
import handleErrors from '../utils/_handleErrors';
import { isAtLeast } from '../utils/_breakpoints';

var domFunctions = require('../utils/_domFunctions');

class oFilters extends HTMLDivElement {
    constructor() {
        super();
        this.resetButton = this.querySelector('.btn-reset');
        this.updateGridButton = this.querySelector('section.footer button');
        this.sortingButtons = this.querySelectorAll('.btn-sort');
        this.filterButtons = this.querySelectorAll('.btn-filter');
        this.filterAndSortingButtons = this.querySelectorAll('.btn-sort, .btn-filter');
        this.resetAllButtons = document.querySelector('.js-resetAllPanel');
        this.sidebar = this.closest('[is="o-sidebar"]');
        this.currentPage = getCurrentPageClass();
        this.navigation = document.querySelector('[is="o-navigation"]');
        this.resetFiltersPlp = document.querySelector('.js-filters-reset');
        this.urlWithoutRefinements = document.querySelector('.js-pagination');
        this.datalayerFiltersUrl;
        this.refinementsRules;
        this.resultCount = '';
        this.selectedItems = {};
        this.previousGtmPageData = [];

        this.fetchSelectedFilterCount = this.fetchSelectedFilterCount.bind(this);
        this.toggleBtn = this.toggleBtn.bind(this);
        this.getSelectedFilters = this.getSelectedFilters.bind(this);
        this.updateGrid = this.updateGrid.bind(this);
        this.reinitSelectedFilters = this.reinitSelectedFilters.bind(this);
        this.handleFilterTitles = this.handleFilterTitles.bind(this);
        this.getTotalActiveButtons = this.getTotalActiveButtons.bind(this);
        this.toggleResetLink = this.toggleResetLink.bind(this);
        this.handleSidebarTotalCount = this.handleSidebarTotalCount.bind(this);
        this.reinitializeEventListeners = this.reinitializeEventListeners.bind(this);
        this.getFiltersData = this.getFiltersData.bind(this);
        this.resetPanelFilters = this.resetPanelFilters.bind(this)
        this.updateFilterState = this.updateFilterState.bind(this)

        this.updateGridButton.setAttribute('disabled', true);
    }

    connectedCallback() {
        if (this.resetAllButtons) {
            this.resetAllButtons.addEventListener('click', this.resetPanelFilters);
            this.resetAllButtons.addEventListener('click', (event) => {
                this.updateFilterState(event);
            });
        }

        if (this.filterAndSortingButtons) {
            for (const button of this.filterAndSortingButtons) {
                button.addEventListener('click', this.fetchSelectedFilterCount);
            }
        }

        if (this.updateGridButton) {
            this.updateGridButton.addEventListener('click', this.updateGrid);
            this.updateGridButton.addEventListener('click', this.getFiltersData);
        }

        var scrollableElement = this.querySelector('.slide-panel');

        if (isAtLeast('md')) { // a bit useless on mobile where scrollbar hides automaticly ?
            this.scrollbar = new PerfectScrollbar(scrollableElement, { suppressScrollX: true });
            this.scrollbar.update();
        }

        const dataInput = this.sidebar.querySelector('input');
        const totalFilters = this.getTotalActiveButtons();
        var dataRefinementNames = JSON.parse(dataInput.dataset.refinementsNames);
        if (dataRefinementNames) {
            this.selectedItems = dataRefinementNames;
            const maincontent = this.closest('#maincontent');
            const filterSpan = maincontent.querySelector('[is="m-plp-bar"] button span.filter-count');
            filterSpan.innerHTML = totalFilters ? `&nbsp;(${totalFilters})` : '';
        }
        this.toggleResetLink(!!totalFilters);

        this.sidebar.addEventListener('oSidebar:onCloseSlidebar', this.reinitSelectedFilters);

        this.resetFiltersPlp.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.urlWithoutRefinements.dataset.currentUrl) {
                window.location = this.urlWithoutRefinements.dataset.currentUrl;
            } else {
                window.location.reload();
            }
            
        });
    }

    toggleResetLink(isVisible) {
        if (this.resetFiltersPlp) {
            if (isVisible) {
                this.resetFiltersPlp.classList.add('d-md-flex');
            } else {
                this.resetFiltersPlp.classList.remove('d-md-flex');
            }
        }
    }

    toggleBtn(e) {
        e.currentTarget.classList.toggle('active');
        this.fetchSelectedFilterSorting(e.currentTarget);
    }

    reinitSelectedFilters() { // runs on filters sidebar closing
        const orgFilters = this.sidebar.querySelector('[is="o-filters"]');
        const filters = orgFilters.querySelectorAll('[is="m-accordion"]');
        if (Object.keys(this.selectedItems).length) {
            filters.forEach((filter) => {
                const selectedFilters = filter.querySelectorAll('div.accordion-panel:not(.sorting) li button');
                selectedFilters.forEach((item, i) => {
                    if (filter.id && this.selectedItems[filter.id].indexOf(i) > -1) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                });
            });
        } else {
            filters.forEach((filter) => {
                const selectedFilters = filter.querySelectorAll('div.accordion-panel:not(.sorting) li button');
                selectedFilters.forEach((item) => {
                    item.classList.remove('active');
                });
            });
        }
        this.handleSidebarTotalCount();
        this.handleFilterTitles();
    }

    handleFilterTitles() {
        const orgFilters = this.sidebar.querySelector('[is="o-filters"]');
        const filters = orgFilters.querySelectorAll('[is="m-accordion"]');
        filters.forEach(filter => {
            const selectedFilters = [...filter.querySelectorAll('div.accordion-panel:not(.sorting) li button, div.accordion-panel:not(.sorting) li input')]
                        .filter(item => {
                            return item.classList.contains('active');
                        }).length;
            if (filter.querySelector('span.filter-count')) {
                filter.querySelector('span.filter-count').innerHTML = selectedFilters ? `(${selectedFilters})` : '';
            }
        });
    }

    handleSidebarTotalCount() {
        const totalFilterCount = this.sidebar.querySelector('div.title-bar span.t-product-filter-count');
        const totalFilters = this.getTotalActiveButtons();
        totalFilterCount.innerHTML = totalFilters ? `(${totalFilters})` : '';
    }

    getTotalActiveButtons(isSorting) {
        const query = isSorting ? '[is="m-accordion"] #filters-sorting-panel' : '[is="m-accordion"] div.accordion-panel:not(.sorting)';
        const orgFilters = this.sidebar.querySelector('[is="o-filters"]');
        const selectedFilters = orgFilters.querySelectorAll(`${query} li .btn.active`);
        return selectedFilters.length;
    }

    updateFilterState(e) {
        let filterCountEndpoint;
        let filterSearch;
        // new call to retrieve new DOM entries following resets
        this.filterPanel = document.querySelector('#o-sidebar-filters .slide-panel');
        this.updateGridButton = this.filterPanel.querySelector('section.footer button');
        this.filterButtons = this.filterPanel.querySelectorAll('.btn-filter');
        this.resetAllButtons = this.filterPanel.querySelector('.js-resetAllPanel');

        const pageTypes = ['plp', 'landing', 'home'];

        if (pageTypes.includes(this.currentPage)) { // Page Designer PLP
            filterCountEndpoint = this.resetAllButtons.dataset.hrefPd;
            filterSearch = this.updateGridButton.dataset.searchPd;
        } else if (this.currentPage === 'search') { // Search Results not PD
            filterCountEndpoint = this.resetAllButtons.dataset.href;
            filterSearch = this.updateGridButton.dataset.search;
        }

        // In case of sorting, remove previously acivated button
        if (e.currentTarget.classList.contains('btn-sort')) {
            var alreadyActivatedButton = e.currentTarget.closest('.accordion-panel-inner').querySelector('.btn.active');
            if (alreadyActivatedButton && alreadyActivatedButton !== e.currentTarget) {
                alreadyActivatedButton.classList.remove('active');
            }
        }

        this.sidebar.classList.add('no-loader', 'loading'); // add a white layer over sidebar to prevent re-cliking before response return

        // In case of reset button, remove 'active' class from all button
        if (e.currentTarget === this.resetButton || e.currentTarget === this.resetAllButtons) {
            var activeButtons = this.filterPanel.querySelectorAll('.btn.active');
            for (let activeButton of activeButtons) {
                activeButton.classList.remove('active');
                activeButton.removeAttribute('checked');
            }

            filterSearch = this.resetButton.dataset.reset;
            this.sidebar.classList.remove('no-loader', 'loading');
        } else {
            e.currentTarget.classList.toggle('active');
        }

        const urls = this.getSelectedFilters(filterCountEndpoint, filterSearch);
        this.updateGridButton.dataset.url = urls.updateGridUrl;

        return urls;
    }

    fetchSelectedFilterCount(e) {
        var urls = this.updateFilterState(e);
        var initUrl = document.location.origin + document.location.pathname;

        if (urls.countUrl) {
            fetch(urls.countUrl, {
                Method: 'GET'
            })
            .then(handleErrors)
            .then((response) => response.json())
            .then((response) => {
                this.handleFilterTitles();
                this.handleSidebarTotalCount();
                this.sidebar.classList.remove('no-loader', 'loading'); // remove white layer
                if (response.resultCount >= 0 && response.btnTextSeeProducts) {
                    this.resultCount = response.resultCountString;
                    this.updateGridButton.textContent = response.btnTextSeeProducts;
                    if (response.resultCount === 0) {
                        this.updateGridButton.setAttribute('disabled', true);
                    } else {
                        this.updateGridButton.removeAttribute('disabled');
                        window.history.pushState({}, '', initUrl);
                    }
                }

                this.refinementsRules = response.currentUrl;

                for (let buttonFilter of this.filterButtons) {
                    let isActive = false;
                    buttonFilter.removeAttribute('disabled');

                    for (let filters of response.selectedIndexes) {
                        let valueFilter = filters.value || filters.displayValue;
                        let btnFilterValue = buttonFilter.id;
                        if ((buttonFilter.defaultValue === "kz_category_only") || (buttonFilter.defaultValue === "kz_gender")) {
                            btnFilterValue = buttonFilter.dataset.prefv;
                        }
                        if (valueFilter === btnFilterValue) {
                            isActive = true;

                        }
                    }

                    if (!isActive) {
                        buttonFilter.setAttribute('disabled', true);
                    }

                    e.target.removeAttribute('disabled');
                }
            });
        }
    }

    getSelectedFilters(countEndPoint, updateGridEndpointParam) {
        var selectedButtons = Array.prototype.slice.call(this.querySelectorAll('.btn.active'));
        var params = new URLSearchParams();
        var updateGridEndpoint = updateGridEndpointParam;
        var map = {};
        // new call to retrieve new DOM entries following resets
        this.filterPanel = document.querySelector('#o-sidebar-filters .slide-panel');
        this.updateGridButton = this.filterPanel.querySelector('section.footer button');

        for (let button of selectedButtons) {
            if (button.classList.contains('btn-sort')) {
                // Button is for sorting (should happen only once)
                let sortName = button.dataset.sortn;
                let sortValue = button.dataset.sortv;
                if (button.dataset.sortn && button.dataset.sortv) {
                    params.set(sortName, sortValue);
                }

                // get the category URL if we are on PLP and selected only sort filter to display push
                if (
                    button.dataset.url.length
                    && document.querySelectorAll('.btn-filter.active').length === 0
                ) {
                    updateGridEndpoint = button.dataset.url;
                }
            } else {
                // Button is for filtering
                let prefName = button.dataset.prefn;
                let prefValue = button.dataset.prefv;

                if (prefName && prefValue) {
                    if (map[prefName]) { // if pref already in querystring, add value with a pipe
                        const value = map[prefName];
                        map[prefName] = `${value}|${prefValue}`;
                    } else {
                        map[prefName] = prefValue;
                    }
                }
            }
        }

        Object.keys(map).forEach(function (key, index) {
            params.set('prefn' + (index + 1), key);
            params.set('prefv' + (index + 1), map[key]);
        });

        this.datalayerFiltersUrl = `${this.updateGridButton.dataset.filters}&${params.toString()}`;

        return {
            countUrl: `${countEndPoint}&${params.toString()}`,
            updateGridUrl: `${updateGridEndpoint}&${params.toString()}`,
            updateFilterUrl: `${this.updateGridButton.dataset.filters}&${params.toString()}`
        };
    }

    scrollToTop() {
        const element = document.querySelector('.experience-dynamic-productList, .plp-search-result, .plp-no-decorator');

        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const paddingAbove = 72;
            const adjustedPosition = elementPosition - paddingAbove;
    
            window.scrollTo({ top: adjustedPosition, behavior: 'smooth' });
        }
    }

    updateGrid() {
        const totalActiveFilters = this.getTotalActiveButtons();
        const isSorting = this.getTotalActiveButtons(true);
        this.toggleResetLink(!!totalActiveFilters);
        const updateGridUrl = (totalActiveFilters || isSorting) ? this.updateGridButton.dataset.url : this.resetAllButtons.dataset.reset;
        this.navigation.waitBeforeScrollEvent = true;

        if (updateGridUrl) {
            this.sidebar.classList.add('loading'); // adds a white layer

            fetch(updateGridUrl, { method: 'GET' })
                .then(handleErrors)
                .then((response) => response.text())
                .then((response) => {
                    this.sidebar.classList.remove('loading'); // removes white layer
                    const newHtml = domFunctions.stringToHTML(response);
                    const metaDataTitleElement = newHtml.querySelector('[data-meta-data-title]');
                    if (metaDataTitleElement && metaDataTitleElement.dataset.metaDataTitle) {
                        document.title = metaDataTitleElement.dataset.metaDataTitle;
                    }
                    var container = document.querySelector('#plp-container-ajax');
                    const sidebarEl = this.closest("[is='o-sidebar']");
                    sidebarEl.trap.deactivate();
                    unlock(sidebarEl.querySelector('.slide-panel'));
                    setTimeout(() => { // tell o-navigation to restart listening…
                        this.navigation.waitBeforeScrollEvent = false;
                    }, 600);

                    const pageTypes = ['plp', 'landing', 'home'];

                    // if we apply only sort filter or reset filters and we are on category : add push from page designer
                    if (
                        document.querySelectorAll('.btn-filter.active').length === 0
                        && pageTypes.includes(this.currentPage)
                    ) {
                        container.parentNode.outerHTML = response;
                    } else {
                        container.outerHTML = response;
                    }

                    var resultCount = document.querySelector('#plp-result-count');
                    if (resultCount && this.resultCount) {
                        resultCount.innerHTML = this.resultCount;
                    }

                    // Update url with curent refinement for back button
                    if (this.refinementsRules) {
                        window.history.pushState({}, '', this.refinementsRules);
                    }

                    setTimeout(() => {
                        this.scrollToTop();
                    }, 600);
                });
        }
    }

    getFiltersData() {
        const totalActiveFilters = this.getTotalActiveButtons();
        this.toggleResetLink(!!totalActiveFilters);
    
        fetch(this.datalayerFiltersUrl, {
            method: 'POST'
        })
        .then(handleErrors)
        .then((response) => response.json())
        .then((responseData) => {
            // get filter by event
            if (responseData.gtmPageData) {
                window.dataLayer = window.dataLayer || [];
    
                const existingFiltersInDataLayer = window.dataLayer.filter(event => 
                    event.event === 'filter_by'
                );
                const currentGtmPageData = responseData.gtmPageData;
    
                const newFilters = currentGtmPageData.filter(current =>
                    !existingFiltersInDataLayer.some(previous =>
                        current.filters_name === previous.filter_choice && current.filters_value === previous.filter_option
                    )
                );
    
                newFilters.forEach(newFilter => {
                    const alreadyExists = existingFiltersInDataLayer.some(event => 
                        event.filter_choice === newFilter.filters_name && 
                        event.filter_option === newFilter.filters_value
                    );
    
                    if (!alreadyExists) {
                        window.dataLayer.push({
                            event: "filter_by",
                            filter_choice: newFilter.filters_name,
                            filter_option: newFilter.filters_value
                        });
                    }
                });
            }

            // get view item list event
            if (responseData.gtmEvent) {
                document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                    detail: {
                        data: responseData.gtmEvent
                    }
                }));
            }
        })
        .catch((error) => {
            console.error('Error when retrieving filters:', error);
        });
    }

    reinitializeEventListeners(container) {
        const updateGridButton = container.querySelector('section.footer button');
        if (updateGridButton) {
            updateGridButton.addEventListener('click', this.updateGrid);
            updateGridButton.addEventListener('click', this.getFiltersData);
        }
    
        const filterButtons = container.querySelectorAll('.btn-sort, .btn-filter');
        for (const button of filterButtons) {
            button.addEventListener('click', this.fetchSelectedFilterCount);
        }
    
        const resetBtn = container.querySelector('.js-resetAllPanel');
        if (resetBtn) {
            resetBtn.addEventListener('click', (event) => {
                this.updateFilterState(event);
            });
            resetBtn.addEventListener('click', this.resetPanelFilters);
        }

        const closePanel = container.querySelector('.close');
        closePanel.addEventListener('click', () => {
            document.dispatchEvent(new CustomEvent('oSidebar:onCloseSlidebar', { detail: { sidebarId: this.sidebar.id, sidebar: this.sidebar } }));
        });
    }

    resetPanelFilters(e) {
        var initUrl = this.updateGridButton.dataset.url;
        window.history.pushState({}, '', initUrl);

        fetch(this.resetAllButtons.dataset.resetAll, {
            Method: 'GET'
        })
        .then(handleErrors)
        .then((response) => response.text())
        .then((response) => {
            var container = document.querySelector('#o-sidebar-filters .slide-panel');
            container.innerHTML = response;

            container = document.querySelector('#o-sidebar-filters .slide-panel');
    
            // Réattacher les événements après avoir remplacé le contenu
            this.reinitializeEventListeners(container);
        });
    }
}

customElements.define('o-filters', oFilters, {
    extends: 'div'
});
